import { FormattedMessage } from 'react-intl';

import styles from './OptionalStatement.module.css';
import { SpinnerComponent } from '../LoadingContainer/WithLoadingSpinner';
import messages from '../TradingHistory.messages';

const OptionalStatement = ({ isLoading }: { isLoading?: boolean }) => {
    return (
        <div className={styles.headingSection}>
            {isLoading && <SpinnerComponent />}
            <h4 className={styles.title}>
                <FormattedMessage {...messages.optionalTitle} />
            </h4>
            <p className={styles.subtitle}>
                <FormattedMessage {...messages.optionalRequirements} />
            </p>
        </div>
    );
};

export default OptionalStatement;
